var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessageRead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 1.66662L11.0601 0.726624L6.83344 4.95329L7.77344 5.89329L12.0001 1.66662ZM14.8268 0.726624L7.77344 7.77996L4.98677 4.99996L4.04677 5.93996L7.77344 9.66662L15.7734 1.66662L14.8268 0.726624ZM0.273438 5.93996L4.0001 9.66662L4.9401 8.72662L1.2201 4.99996L0.273438 5.93996Z",
    fill: "#959EBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageRead);
export default __webpack_public_path__ + "static/media/iconMessageRead.589a31fa6b5587419f4e5fad8e897e69.svg";
export { ForwardRef as ReactComponent };